module.exports = __webpack_public_path__ + "img/logo_small.682918d7.png";